<template>
  <div class="app">
    <div class="m-viewport" id="mainView" :style="{'height' : fullHeight + 'px' }">

       <div class="cover" :class="{hidden: !showCover}" @click="skipCover">
            <video
                :src="'https://web-resource.17m3.com/m3guo/202601/fes/opening.mp4?v=' + randomKey"
               autoplay
               muted
               playsinline
                webkit-playsinline
                preload="auto"
                @ended="onCoverEnded"               
            ></video>
            <!--  -->
        </div>

        <div class="logo-view">
          <h2 class="logo_1 sprite sprite-logo"><a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a></h2>
        </div>
        
        <div class="u-links">
            <div class="btn-index sprite sprite-btn-index">
                <a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a>
            </div>
            <div class="btn-dl sprite sprite-btn-dl">
              <a href="https://www.m3guo.com/v2/download/client/" target="_blank" rel="noopener noreferrer"></a>
            </div>
        </div>
        
        <div class="u-btn copyright">
            <!-- todo -->
        </div>
        
        <loading v-show="Loading"/>
     
        <div class="page-body swiper">

            <swiper ref="main" :options="swiperOptions">
                <swiper-slide class="swiper-no-swiping">
                    <div class="page-wrapper cover-index" id="index">
                        

                        <div class="d-view">

                            <!-- <div class="layer-center"></div> -->
                            

                            <div class="carousel3d" id="imgs">
                                
                                <div class="el" v-for="n in 7" :key="n">
                                        <div class="card-item" :class="'c-' + n"
                                        @click="swiper.slideTo( n + 1, 400, false);main_index = (n+1)"></div>
                                </div>

                                <div class="layer-center"></div>

                                
                            </div>

                            
                            

                            <div class="u-btn gift"
                            @click="swiper.slideTo( 1, 400, false);main_index = 1"></div>                            
                        </div>


                        <!-- <div class="cards-view">

                            <div class='container'>
                              <div class='el' v-for="n in 7" :key="n" :style="`transform: rotateY(${ (n - 1) * 51 }deg);`">
                                        <div class="card-item" :class="'c-' + n"
                                        @click="swiper.slideTo( n + 1, 400, false);main_index = (n+1)"></div>
                                </div>                                                            
                                <div class="layer-center"></div> 
                            </div>                            

                            <div class='controls'>
                                <button class='prev'>&#8592;</button>
                                <button class='next'>&#8594;</button>
                            </div>

                            <div class="u-btn gift"
                            @click="swiper.slideTo( 1, 400, false);main_index = 1"></div>
                 
                        </div> -->

                        <div class="layer-header">
                            <div class="main-title"></div>
                        </div>
                    </div>                    
                </swiper-slide>
                <swiper-slide class="swiper-no-swiping">
                    <div class="page-wrapper">
                        <task v-if="ready" :flag="flag"/>
                    </div>
                </swiper-slide>
                <swiper-slide class="swiper-no-swiping">
                    <div class="page-wrapper">
                        <event />
                    </div>
                </swiper-slide>
                <swiper-slide class="swiper-no-swiping">
                    <div class="page-wrapper">
                        <skins />
                    </div>
                </swiper-slide>
                <swiper-slide class="swiper-no-swiping">
                    <div class="page-wrapper">
                        <game-map/>
                    </div>
                </swiper-slide>
                <swiper-slide class="swiper-no-swiping">
                    <div class="page-wrapper">
                        <hero/>
                    </div>
                </swiper-slide>
                <swiper-slide class="swiper-no-swiping">
                    <div class="page-wrapper">
                        <weapon/>
                    </div>
                </swiper-slide>
                <swiper-slide class="swiper-no-swiping">
                    <div class="page-wrapper">
                        <patch/>
                    </div>
                </swiper-slide>
                <swiper-slide class="swiper-no-swiping">
                    <div class="page-wrapper">
                        <fes/>
                    </div>
                </swiper-slide>
            </swiper>


            <div class="nav-swiper" :class="{'active' : main_index > 0 }">
                <div class="tips-mouse"><div class="icon-md"></div></div>
                <div class="nav-item" v-for="n in 9" :key="n" :class="['n-' + (n-1) , {'active': main_index === (n-1)} ]"
                @click="swiper.slideTo(n-1, 400, false);main_index = (n-1)"></div>
            </div>            
        </div>

    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

import {
    apiRead,
} from '@/api/index';

export default {
    name: 'mainview',
    components: {
        loading: () => import('@/components/loading.vue'),
        task : () => import('@/views/task.vue'),
        event : () => import('@/views/event.vue'),
        skins : () => import('@/views/skins.vue'),
        patch : () => import('@/views/patch.vue'),
        fes : () => import('@/views/fes.vue'),
        'game-map' : () => import('@/views/map.vue'),
        hero : () => import('@/views/newHero.vue'),
        weapon : () => import('@/views/weapon.vue'),
    },
    data (){
        return {
            sns : false,
            main_index: 0,
            read : [0,0,0,0,0,0,0],
            flag : 0,
            Swiper0: null,
            fullHeight : 918,
            // mouse control for carousel
            _mouseOffsetTarget: 0,
            _mouseOffset: 0,
            _mouseMaxOffset: 60, // px -> deg 映射的最大偏移角度（可调）
            _carouselMouseRaf: null,
            _carouselMouseInited: false,            
            randomKey : Math.random().toString(36).substring(2,8),
            showCover: true, //控制开屏显示
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination',    //与slot="pagination"处 class 一致
                    clickable: true,            //轮播按钮支持点击
                },
                noSwiping : true,
                direction: 'vertical',
                mousewheel: true,//开启鼠标滚轮控制滑动
                on: {
                    slideChangeTransitionStart: () => {
                        this.main_index = this.$refs.main.swiper.activeIndex;
                    }
                }                
            },            
        }
    },
    mounted() {
        //旋转动画1
        let vm = this;

        // setInterval(function(){
        //     vm.card_move()
        // },6000)

        this.startCarouselAuto();

        // 初始化并绑定可视高度计算
        this.updateFullHeight();
        this._onResizeFullHeight = () => { this.updateFullHeight(); };
        window.addEventListener('resize', this._onResizeFullHeight, { passive: true });
    },    
    beforeDestroy() {
        if (this._onResizeFullHeight) window.removeEventListener('resize', this._onResizeFullHeight);
        if (this._cardMoveRaf) cancelAnimationFrame(this._cardMoveRaf);
    }, 
    computed : {
        ...mapState(['Loading']),
        swiper() {
            return this.$refs.main.swiper;
        }        
    },
    watch : {
        main_index(newVal){
            //console.log(newVal)
            if(!this.$store.state.userinfo.zid) return;
            if(newVal == 0) return;
            if(this.read[newVal - 1])return;
            if((this.$store.state.userinfo.uflag & 2) == 2)return;
            apiRead({id : (newVal - 1)}).then(
                res => {
                    if(newVal > 0){
                        this.read[newVal - 1] = 1;
                        this.flag = this.read.filter(item => item === 1).length;
                    }
                }
            );
        },        
    },   
    props : {
        ready : {
            default : false,
        },
    },
    methods : {
        // 返回符合规则的高度：当视口高度 < 918 -> 918；当视口高度 >= 918 -> 视口高度，但最大不超过 1080
        computeFullHeight() {
            const h = window.innerHeight || document.documentElement.clientHeight || 918;
            return Math.min(Math.max(h, 918), 1080);
        },
        // 更新 data.fullHeight（在 mounted 与 resize 时调用）
        updateFullHeight() {
            this.fullHeight = this.computeFullHeight();
        },        
        // 视频播放结束或点击跳过时调用，执行淡出并最终隐藏开屏层
        onCoverEnded() {
            // 先触发淡出样式
            this.showCover = false;
            //this.card_move();
            // 可选：在淡出动画后彻底移除或做其它操作
            // setTimeout(() => { this.showCoverRemoved = true; }, 700);
        },
        // 点击跳过
        skipCover() {
            const vid = this.$el.querySelector('.cover video');
            if (vid && !vid.ended) {
                try { vid.pause(); } catch(e){}
            }
            this.onCoverEnded();
        },        
        card_move(e){
            const elements = Array.from(document.querySelectorAll('.el'));
            if (!elements.length) return;

            // 读取当前角度
            const reg = /(-?\d+(\.\d+)?)(?=deg)/;
            const starts = elements.map(el => {
                const style = el.getAttribute('style') || el.style.transform || '';
               const m = reg.exec(style);
                return m ? parseFloat(m[0]) : 0;
            });

            // 动画参数：增量和时长（ms）
            const delta = 51;
            const duration = 6000;

            // 取消上一次动画
            if (this._cardMoveRaf) cancelAnimationFrame(this._cardMoveRaf);
           const t0 = performance.now();

            const step = (ts) => {
                const elapsed = ts - t0;
                const progress = Math.min(1, elapsed / duration); // 线性（匀速）
                elements.forEach((el, i) => {
                    const cur = starts[i] + delta * progress;
                    el.style.transform = `rotateY(${cur}deg)`;
                });

                if (progress < 1) {
                  this._cardMoveRaf = requestAnimationFrame(step);
                } else {
                    this._cardMoveRaf = null;
                }
            };

            this._cardMoveRaf = requestAnimationFrame(step);
        },     
        // 帮助函数：根据当前 angle 为每个 el 应用 translateZ + translateY + z-index + opacity
        updateCarouselPositions(yOffset = 60, maxTranslateZ = 120) {
            const container = document.getElementById('imgs');
            if (!container) return;
            const els = Array.from(container.querySelectorAll('.el'));
            if (!els.length) return;
            els.forEach((el) => {
                const angle = parseFloat(el.dataset.angle ?? (() => {
                    const regDeg = /(-?\d+(\.\d+)?)(?=deg)/;
                    const inline = el.getAttribute('style') || el.style.transform || '';
                   const m = regDeg.exec(inline);
                    return m ? m[0] : 0;
                })());
                const cur = ((angle + 180) % 360) - 180;
                const rad = cur * Math.PI / 180;
                const depth = Math.cos(rad); // -1..1
                const zPx = Math.round(depth * maxTranslateZ);
                const depth01 = (depth + 1) / 2; // 0..1
                // 后面的（depth01 小）应该更低，故用 (1 - depth01) 映射到向下偏移
               const ty = Math.round((1 - depth01) * yOffset); // px
                const zIndex = Math.round(10 + depth01 * 80);
                el.style.transform = `translate3d(-50%,-50%,0) rotateY(${cur}deg) translateZ(${zPx}px) translateY(${ty}px)`;
                el.style.zIndex = String(zIndex);
                el.style.opacity = (0.75 + 0.25 * depth01).toFixed(3);
            });
        },

        rotateCarousel(stepCount = 1, duration = 600) {
            const container = document.getElementById('imgs');
            if (!container) return;
            const els = Array.from(container.querySelectorAll('.el'));
            const count = els.length;
            if (!count) return;

            const stepDeg = 360 / count;
            const delta = stepDeg * stepCount;

            const regDeg = /(-?\d+(\.\d+)?)(?=deg)/;
            const starts = els.map((el, i) => {
                if (el.dataset.angle) return parseFloat(el.dataset.angle);
                const inline = el.getAttribute('style') || el.style.transform || '';
                const m = regDeg.exec(inline);
                if (m) return parseFloat(m[0]);
                return i * stepDeg;
            });

            if (this._carouselRaf) cancelAnimationFrame(this._carouselRaf);

            const t0 = performance.now();
            const maxTranslateZ = 60; // 前后深度（可调）
            const yOffset = 30; // 后方向下偏移最大像素（可调，减小可更 subtle）
            const easing = (t) => 1 - Math.pow(1 - t, 3);

            const stepFn = (ts) => {
                const elapsed = ts - t0;
                const rawProgress = Math.min(1, elapsed / duration);
                const progress = easing(rawProgress);

                els.forEach((el, i) => {
                    let cur = starts[i] + delta * progress;
                    cur = ((cur + 180) % 360) - 180;
                    el.dataset.angle = cur;

                    const rad = cur * Math.PI / 180;
                    const depth = Math.cos(rad);
                    const zPx = Math.round(depth * maxTranslateZ);
                    const depth01 = (depth + 1) / 2;
                    const ty = Math.round((1 - depth01) * yOffset);
                    const zIndex = Math.round(10 + depth01 * 80);

                    el.style.willChange = 'transform, opacity';
                    el.style.transform = `translate3d(-50%,-50%,0) rotateY(${cur}deg) translateZ(${zPx}px) translateY(${ty}px)`;
                    el.style.zIndex = String(zIndex);
                    el.style.opacity = (0.75 + 0.25 * depth01).toFixed(3);
                });

                if (rawProgress < 1) {
                    this._carouselRaf = requestAnimationFrame(stepFn);
                } else {
                    // 确保最终精确值
                    els.forEach((el, i) => {
                        let final = starts[i] + delta;
                        final = ((final + 180) % 360) - 180;
                        el.dataset.angle = final;
                        const rad = final * Math.PI / 180;
                        const depth = Math.cos(rad);
                        const zPx = Math.round(depth * maxTranslateZ);
                        const depth01 = (depth + 1) / 2;
                        const ty = Math.round((1 - depth01) * yOffset);
                        const zIndex = Math.round(10 + depth01 * 80);
                        el.style.transform = `translate3d(-50%,-50%,0) rotateY(${final}deg) translateZ(${zPx}px) translateY(${ty}px)`;
                        el.style.zIndex = String(zIndex);
                        el.style.opacity = (0.75 + 0.25 * depth01).toFixed(3);
                        el.style.willChange = '';
                    });
                    this._carouselRaf = null;
                }
            };

            this._carouselRaf = requestAnimationFrame(stepFn);
        },

        // 快捷：下一格 / 上一格
        carouselNext(duration = 600) { this.rotateCarousel(1, duration); },
        carouselPrev(duration = 600) { this.rotateCarousel(-1, duration); },

        // 可选：连续自动旋转（调用 startCarouselAuto 停止用 stopCarouselAuto）
        startCarouselAuto(interval = 3000, duration = 600) {
            this.stopCarouselAuto();
            this._carouselAutoT = setInterval(() => { this.carouselNext(duration); }, interval);
        },
        stopCarouselAuto() {
            if (this._carouselAutoT) { clearInterval(this._carouselAutoT); this._carouselAutoT = null; }
        },        
    }, 
}
</script>

<style lang="scss" scoped>
.m-viewport{
    position: relative;
    width: 100%;
    height: 918px;
    margin: 0 auto 0;
    box-sizing: border-box;
    font-size: 16px;
    background-color: #341e0d;
    color: #392210;
    overflow-x: hidden;
    overflow-y: hidden;
    // font-family: "HYChangLiSongKeBenJ";

    b{
        font-weight: 400;
        color: #26c7da;        
    }

  .swiper{
    width: 100%;
    
    .swiper-container {
      width: 100%;

      .swiper-slide {
        width: 100%;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
      }

      .swiper-pagination{
        .swiper-pagination-bullet-active{
          background-color: #F29B76;
        }
      }
    }
  }

}

.cover{
    position: absolute;
    left: 50%;
    top: 0;
    width: 2560px;
    height: 1400px;
    transform: translateX(-50%);
    z-index: 20;
    overflow: hidden;
    transition: opacity 0.6s ease, visibility 0.6s;
    opacity: 1;
    pointer-events: auto;

    &.hidden{
        opacity: 0;
        pointer-events: none;
        visibility: hidden;
    }

    video{
        width: 100%;
        height: 100%;
        object-fit: contain;
        border: none;
        mix-blend-mode: darken; 
    }

    video:focus {
        outline:none;
    }


    &::after{
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        height: 384px;
        left: 50%;
        bottom: -1px;
        transform: translateX(-50%);
        //background-image: url(~@/assets/images/pc/layer-video.png);  
    }
}

.u-btn.invite{
    position: fixed;
    right: 2%;
    top: 30%;
    z-index: 10;
}

.logo-view{
    display: flex;
    align-items: center;
    position: absolute;
    left: 2%;
    top:30px;
    z-index: 10;
}

.logo-view a{
    display: block;
    width: 100%;
    height: 100%;
}

.u-links{
    display: flex;
    position: absolute;
    right: 4%;
    top: 30px;
    z-index: 6; 
    
    &>div{
        margin-left: 20px;
    }
}

.u-links a{
    display: block;
    width: 100%;
    height: 100%;
}

.page-body{
    position: relative;
    width: 100%;
    margin: 0 auto;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center top;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: hidden;
    //background-image: url(~@/assets/images/pc/body.jpg);
    background-image: url(~@/assets/images/pc/inner.jpg); 
}

.m-user{
    width: 696px;
    height: 36px;
    line-height: 36px;
    margin: 0 auto;
    text-align: center;
    //background-image: url(~@/assets/images/pc/bg-userinfo.png); 
}

.page-wrapper{
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding-top: 60px;

    &.cover-index{
        background-repeat: no-repeat;
        background-position: center top;        
        background-image: url(~@/assets/images/pc/body.jpg);
    }

    // .layer-center{
    //     position: absolute;
    //     left: 50%;
    //     bottom: -414px;
    //     transform: translate(-50%,0);
    //     width: 496px;
    //     height: 632px;
    //     background-image: url(~@/assets/images/pc/center.png);
    // }

    // .layer-center{
    //     position: absolute;
    //     left: 50%;
    //     bottom: -20px;
    //     transform: translate(-50%,0);
    //     width: 496px;
    //     height: 632px;
    //     background-image: url(~@/assets/images/pc/center.png);
    //     z-index: 4;
    // }


    .layer-header{
        position: absolute;
        left: 50%;
        bottom: 432px;
        transform: translate(-50%,0);
        width: 1812px;
        height: 584px;
        background-image: url(~@/assets/images/pc/layer-head.png); 
        z-index: 99;
        pointer-events: none;
        
        .main-title{
            position: absolute;
            left: 50%;
            top: 140px;
            transform: translate(-50%,0);
            width: 892px;
            height: 214px;
            background-image: url(~@/assets/images/pc/main-title.png);
        }
    }
}

$img : 7;
$rotateStep : 360 / $img;
$rotate : 0;

// .cards-view{
//     position: absolute;
//     left: 50%;
//     bottom: 350px;
//     width: 1280px;
//     height: 200px;
//     transform: translate(-50%,0);
//     // perspective: 1000px;
//     z-index: 2;
    

//     .u-btn.gift{
//         position: absolute;
//         right: -185px;
//         top: -60px;
//         width : 247px;
//         height: 309px;
//         background-image: url(~@/assets/images/pc/btn-share.png);
//         z-index: 5;

//         &:hover{
//             background-image: url(~@/assets/images/pc/btn-shareD.png);
//         }
//     }

//     .container {
//         position: relative;
//         margin: 0 auto 0;
//         width: 1220px;
//         height: 150px;
//         transform-style: preserve-3d;
//         perspective-origin: 50% -50%;
//         perspective: 900px;
//     }

//     .el {
//         position: absolute;
//         width: 1220px;
//         height: 150px;
//         color: #fff;
//         text-align: center;
//         transform-origin: 50% 50% -400px;
//         transition: transform 0.3s ease-in;
//         font-size: 130px;
//     }

//     .card-item{
//         position: relative;
//         width: 222px;
//         height: 377px;  
//         background-image: url(~@/assets/images/pc/cards/2.png);

//         &::before{
//             display: block;
//             content: '';
//             position: absolute;
//             top: -90px;
//             left: 50%;
//             transform: translateX(-50%);
//             width: 31px;
//             height: 120px;
//             background-position: center bottom;
//             background-image: url(~@/assets/images/pc/rope.png);
//         }


//         @for $i from 1 through 7 {
//             &.c-#{$i} {
//                 background-image: url(~@/assets/images/pc/cards/#{$i + 1}.png);
//             }
//         }            
//     }
    
//     @keyframes three-dimensions-circle {
//         0% {
//             transform: rotateX(-100deg) rotate(0);
//         }
//         100% {
//             transform: rotateX(-100deg) rotate(-360deg);
//         }
//     }

// }

.d-view{
position: absolute;
left: 50%;
bottom: 0;
margin-left: -700px;
perspective:1000px;
transform-style: preserve-3d;
width: 1400px;
height: 632px;
// margin: 0 auto;

.layer-center{
    position: absolute;
    left: 50%;
    bottom: -360px;
    transform: translate(-50%,0);
    width: 496px;
    height: 632px;
    background-image: url(~@/assets/images/pc/center.png);
    /* 提高到中间层，脚本会把卡片 z-index 设在 0..100 范围，柱子在 50 */
    z-index: 50;
}


.carousel3d{  
  position:absolute;
  top:310px; 
  left:50%;
  transform-style: preserve-3d;
  transform-origin:0 0 -50vw;
    .el{
        position:absolute;
        top:0;
        left:0;
        transform-origin:50% 50% -500px;
        transform:translate3d(-50%,-50%,0);
        transform-style: preserve-3d;
    }

    .card-item{
        position: relative;
        width: 222px;
        height: 377px;  
        background-image: url(~@/assets/images/pc/cards/2.png);

        &::before{
            display: block;
            content: '';
            position: absolute;
            top: -270px;
            left: 50%;
            transform: translateX(-50%);
            width: 31px;
            height: 270px;
            background-position: center bottom;
            background-image: url(~@/assets/images/pc/rope.png);
        }


        @for $i from 1 through 7 {
            &.c-#{$i} {
                background-image: url(~@/assets/images/pc/cards/#{$i + 1}.png);

                // &:hover{
                //     background-image: url(~@/assets/images/pc/cards/#{$i + 1}D.png);
                // }
            }
        }            
    }

}

.u-btn.gift{
    position: absolute;
    top: 25px;
    right: -30px;
    width : 247px;
    height: 309px;
    background-image: url(~@/assets/images/pc/btn-share.png);
    z-index: 5;

    &:hover{
        background-image: url(~@/assets/images/pc/btn-shareD.png);
    }
}

@for $i from 0 through $img {
  $rotate : $rotateStep * $i;
  #imgs .el:nth-child(#{$i + 1}) {
     transform: translate3d(-50%,-50%,0) rotate3d(0,1,0,$rotate+deg);
  }
}

}

.nav-swiper {
    position: absolute;
    left: 50%;
    bottom: -400px;
    transform: translateX(-50%);
    z-index: 30;
    width: 100%;
    height: 62px;
    padding: 0 66px;
    transition: all .8s ease-in-out;
    display: flex;
    justify-content: center;

    &::after{
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-image: url(~@/assets/images/pc/bg-bottom_nav.png);
        background-position: center top;
        background-repeat: no-repeat;
        z-index: -1;
    }

    .tips-mouse{
        position: absolute;
        left: 50%;
        top: -100px;
        width: 174px;
        height: 24px;
        margin-left: -87px;
        background-image: url(~@/assets/images/pc/md.png);

        .icon-md{
            position: absolute;
            left: 50%;
            top: 50%;
            width: 43px;
            height: 44px;
            margin: -22px 0 0 -21.5px;
            background-image: url(~@/assets/images/pc/icon-md.png);
            animation: float_up 4s linear infinite;
        }
    }

    &.active {
        bottom: 0;
    }

    .nav-item{
        position: relative;
        top: -40px;
        width: 101px;
        height: 100px;
        margin: 0 15px;

        @for $i from 0 through 8 {
            &.n-#{$i} {
                background-image: url(~@/assets/images/pc/nav/#{$i}.png);
            }

            &.n-#{$i}:hover,&.n-#{$i}.active{
                background-image: url(~@/assets/images/pc/nav/#{$i}--D.png);
            }
        }        
    }
}

</style>
